<div class="content-wrapper container-xxl p-0">
    <div class="content-body">
        <div class="row justify-content-center d-flex flex-wrap p-0 m-0 persona-container">

            <div class="col-6 col-md-3 text-center">
                <div class="black-theme-link">
                    <div class="persona-card" (click)="selectProfile('TRAVELLER')" [ngClass]="{'selected-profile': selectedProfile === 'TRAVELLER'}">
                        <img src="assets/images/illustration/traveler-personal-icon.webp">
                        <h4 class="mt-2">Traveler</h4>
                        <p class="persona-short-info">Wander more, worry less with our smart Forex Cards & Currency Solutions</p>
                    </div>
                </div>
            </div>

            <div class="col-6 col-md-3 text-center">
                <div class="black-theme-link">
                    <div class="persona-card" (click)="selectProfile('STUDENT')" [ngClass]="{'selected-profile': selectedProfile === 'STUDENT'}">
                        <img src="assets/images/illustration/persona-student-icon.webp">
                        <h4 class="mt-2">Student</h4>
                        <p class="persona-short-info">Fast, Secure & Hassle Free Solutions for University Fee Payment and Living Expenses</p>
                    </div>
                </div>
            </div>

            <div class="col-6 col-md-3 text-center">
                <div class="black-theme-link" href="#">
                    <div class="persona-card" (click)="selectProfile('BUSINESS')" [ngClass]="{'selected-profile': selectedProfile === 'BUSINESS'}">
                        <img src="assets/images/illustration/persona-business-icon.webp">
                        <h4 class="mt-2">Business</h4>
                        <p class="persona-short-info">Pay Smart-Business Travel made effortless with end to end Forex Solutions</p>
                    </div>
                </div>
            </div>

            <div class="col-6 col-md-3 text-center">
                <div class="black-theme-link" >
                    <div class="persona-card" (click)="selectProfile('PERSONAL')" [ngClass]="{'selected-profile': selectedProfile === 'PERSONAL'}">
                        <img src="assets/images/illustration/persona-personal-icon.webp">
                        <h4 class="mt-2">Personal</h4>
                        <p class="persona-short-info">Your one-stop for all Personal Remittances-Safe, Secure & Seamless</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 text-center">
                <button class="btn btn-primary" (click)="setProfile()">Update</button>
            </div>
        </div>
    </div>
</div>